// extracted by mini-css-extract-plugin
module.exports = {"truncated-text":"TruncatedText_truncated-text__VchW0","is-hovered":"TruncatedText_is-hovered__EANQh"};